export const config = {
  AboutIntro: {
    title: 'About you',
  },
  AboutYouForm: {
    sectionDataTest: 'YourAppointmentChildrensShoeFitting',
  },
};
